module.exports = __webpack_public_path__ + "img/store.ae019fe8.svg";